(function() {
  'use strict';

  var initialized = false;

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function parseNumber(value) {
    var number = Number(value);
    return Number.isFinite(number) ? number : 0;
  }

  function formatMoney(amount, currencyCode) {
    var number = parseNumber(amount);
    try {
      return new Intl.NumberFormat('ja-JP', {
        style: 'currency',
        currency: currencyCode || 'JPY',
        maximumFractionDigits: 0
      }).format(number);
    } catch (error) {
      return '¥' + Math.round(number).toLocaleString('ja-JP');
    }
  }

  function getProductId(product) {
    var id = product.numeric_id || product.id || '';
    var match = String(id).match(/(\d+)$/);
    return match ? match[1] : String(id);
  }

  function parseReviewNumber(value) {
    var number = Number(value);
    return Number.isFinite(number) ? number : 0;
  }

  function appendRef(url, ref) {
    if (!ref) {
      return url;
    }

    try {
      var parsedUrl = new URL(url, window.location.origin);
      parsedUrl.searchParams.set('ref', ref);
      if (parsedUrl.origin === window.location.origin) {
        return parsedUrl.pathname + parsedUrl.search + parsedUrl.hash;
      }
      return parsedUrl.toString();
    } catch (error) {
      return url + (url.indexOf('?') === -1 ? '?' : '&') + 'ref=' + encodeURIComponent(ref);
    }
  }

  function buildApiUrl(endpoint, handle, limit, tag, tags, type) {
    var url = new URL(endpoint, window.location.origin);
    url.searchParams.set('handle', handle);
    url.searchParams.set('limit', limit);
    if (tag) {
      url.searchParams.set('tag', tag);
    }
    tags.forEach(function(value, index) {
      if (value) url.searchParams.set('name' + (index + 1), value);
    });
    if (tags.some(Boolean)) url.searchParams.set('type', type);
    return url.toString();
  }

  function normalizeProduct(product) {
    var price = product.price || {};
    var compareAtPrice = product.compare_at_price || product.compareAtPrice || {};
    var image = product.image || {};

    return {
      title: product.title || '',
      url: product.url || (product.handle ? '/products/' + product.handle : '#'),
      imageUrl: image.url || product.image_url || '',
      imageAlt: image.alt || product.image_alt || product.title || '',
      available: product.available !== false,
      priceAmount: price.amount || product.price_amount || product.price || 0,
      priceCurrency: price.currency || product.currency || 'JPY',
      compareAtAmount: compareAtPrice.amount || product.compare_at_price_amount || 0,
      productId: getProductId(product),
      reviewBadge: product.review_badge || product.reviewBadge || '',
      reviewAverage: product.review_average || product.reviewAverage || '',
      reviewCount: product.review_count || product.reviewCount || ''
    };
  }

  function renderManualReviewBadge(item) {
    var average = parseReviewNumber(item.reviewAverage);
    var count = parseReviewNumber(item.reviewCount);
    var ratingSteps = Math.round(average * 2);

    if (!average || !count) {
      return '';
    }

    var stars = '';
    for (var i = 1; i <= 5; i += 1) {
      var fullStep = i * 2;
      var halfStep = fullStep - 1;
      var starClass = '';

      if (ratingSteps >= fullStep) {
        starClass = ' is-filled';
      } else if (ratingSteps === halfStep) {
        starClass = ' is-half';
      }

      stars += '<span class="category-ranking__review-star' + starClass + '">★</span>';
    }

    return [
      '<div class="category-ranking__review" aria-label="' + escapeHtml(average) + ' / 5 stars, ' + escapeHtml(count) + ' reviews">',
        '<span class="category-ranking__review-stars" aria-hidden="true">' + stars + '</span>',
        '<span class="category-ranking__review-count">(' + escapeHtml(count) + ')</span>',
      '</div>'
    ].join('');
  }

  function renderReviewBadge(item) {
    var manualReviewBadge = renderManualReviewBadge(item);

    if (manualReviewBadge) {
      return manualReviewBadge;
    }

    return [
      '<div class="jdgm-widget jdgm-preview-badge" data-id="' + escapeHtml(item.productId) + '" data-auto-install="false">',
        item.reviewBadge || '',
      '</div>'
    ].join('');
  }

  function refreshJudgeMeBadges() {
    window.setTimeout(function() {
      if (!window.jdgm) return;
      if (typeof window.jdgm.initializeBadges === 'function') {
        window.jdgm.initializeBadges();
      } else if (typeof window.jdgm.renderBadges === 'function') {
        window.jdgm.renderBadges();
      }
    }, 0);
  }

  function renderProduct(product, sectionId, options) {
    var item = normalizeProduct(product);
    var compareAt = parseNumber(item.compareAtAmount);
    var price = parseNumber(item.priceAmount);
    var isSale = compareAt > price && price > 0;
    var productUrl = appendRef(item.url, options.ref);
    var taxLabel = options.includeTax ? '&nbsp;<span class="product__price_tax">(税込)</span>' : '';
    var cta = options.ctaLabel
      ? '<a class="cat-ranking-btn" href="' + escapeHtml(productUrl) + '">' + escapeHtml(options.ctaLabel) + '</a>'
      : '';

    return [
      '<li class="grid__item grid__item--' + escapeHtml(sectionId) + ' small--one-half medium-up--one-third category-ranking__item">',
        '<div class="grid-view-item' + (item.available ? '' : ' grid-view-item--sold-out') + ' product-card">',
          '<a class="grid-view-item__link grid-view-item__image-container full-width-link" href="' + escapeHtml(productUrl) + '">',
            '<span class="visually-hidden">' + escapeHtml(item.title) + '</span>',
          '</a>',
          '<div class="product-card__image-with-placeholder-wrapper" data-image-loading-animation>',
            '<div class="grid-view-item__image-wrapper product-card__image-wrapper js">',
              '<div class="category-ranking__image-frame">',
                item.imageUrl
                  ? '<img class="grid-view-item__image category-ranking__image" src="' + escapeHtml(item.imageUrl) + '" alt="' + escapeHtml(item.imageAlt) + '" loading="lazy" style="width:100%;height:100%;object-fit:contain;font-family:\'object-fit: contain\';">'
                  : '',
              '</div>',
            '</div>',
          '</div>',
          '<div class="h4 grid-view-item__title product-card__title" aria-hidden="true">' + escapeHtml(item.title) + '</div>',
          renderReviewBadge(item),
          '<dl class="price price--listing' + (isSale ? ' price--on-sale' : '') + (item.available ? '' : ' price--sold-out') + '">',
            '<div class="price__regular">',
              '<dt><span class="visually-hidden">通常価格</span></dt>',
              '<dd><span class="price-item price-item--regular">' + formatMoney(item.priceAmount, item.priceCurrency) + taxLabel + '</span></dd>',
            '</div>',
            isSale
              ? '<div class="price__sale"><dt><span class="visually-hidden">販売価格</span></dt><dd><span class="price-item price-item--sale">' + formatMoney(item.priceAmount, item.priceCurrency) + taxLabel + '</span></dd><dt><span class="visually-hidden">通常価格</span></dt><dd><s class="price-item price-item--regular">' + formatMoney(item.compareAtAmount, item.priceCurrency) + '</s></dd></div>'
              : '',
          '</dl>',
          item.available ? '' : '<span class="product-card__badge">売り切れ</span>',
        '</div>',
        cta,
      '</li>'
    ].join('');
  }

  function setMessage(root, message) {
    var messageEl = root.querySelector('[data-category-ranking-message]');
    if (!messageEl) return;
    messageEl.textContent = message || '';
    messageEl.hidden = !message;
  }

  function initRanking(root) {
    if (root.getAttribute('data-category-ranking-loaded') === 'true') {
      return;
    }

    var endpoint = root.getAttribute('data-api-endpoint');
    var handle = root.getAttribute('data-collection-handle');
    var limit = root.getAttribute('data-limit') || '10';
    var tag = root.getAttribute('data-current-tag') || '';
    var tags = [1, 2, 3].map(function(index) {
      return root.getAttribute('data-ranking-tag' + index) || '';
    });
    var type = root.getAttribute('data-ranking-type') || 'or';
    var options = {
      ref: root.getAttribute('data-ref') || '',
      ctaLabel: root.getAttribute('data-cta-label') || '',
      includeTax: root.getAttribute('data-include-tax') !== 'false'
    };
    var list = root.querySelector('[data-category-ranking-list]');
    var section = root.closest('[data-section-id]');
    var sectionId = section ? section.getAttribute('data-section-id') : 'category-ranking';

    if (!endpoint || !handle || !list) {
      root.hidden = true;
      return;
    }

    root.setAttribute('data-category-ranking-loaded', 'true');

    fetch(buildApiUrl(endpoint, handle, limit, tag, tags, type), { credentials: 'omit' })
      .then(function(response) {
        if (!response.ok) {
          throw new Error('Ranking API error: ' + response.status);
        }
        return response.json();
      })
      .then(function(data) {
        var products = Array.isArray(data.products) ? data.products : [];
        if (!products.length) {
          root.hidden = true;
          return;
        }

        list.innerHTML = products.map(function(product) {
          return renderProduct(product, sectionId, options);
        }).join('');
        refreshJudgeMeBadges();
        setMessage(root, '');
      })
      .catch(function(error) {
        console.warn('[category-ranking] failed to load', error);
        list.innerHTML = '';
        setMessage(root, 'ランキングを読み込めませんでした。');
      });
  }

  function initAll() {
    if (initialized) return;
    initialized = true;
    document.querySelectorAll('[data-category-ranking]').forEach(initRanking);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
